import { Environment } from './environment.interface'

export const environment: Environment = {
    production: false,
    baseUrl: 'https://app-surefire-api-dev-001.azurewebsites.net/',
    googleRecaptchaKey: '6LduHJYUAAAAAIFfpF-jYjK_EOHT9cQov6wQy8Vc',
}
